export const AUTH_RESET_PASSWORD_REQUEST = 'auth/reset-password-request'
export const AUTH_RESET_PASSWORD_SUCCESS = 'auth/reset-password-success'
export const AUTH_RESET_PASSWORD_FAILED = 'auth/reset-password-failed'
